import React from 'react'

import ModalFormBuilder from 'Skelet/src/components/ModalFormBuilder.js'

import config from '../config.js'


export default class extends React.Component {

  render() {
    return <ModalFormBuilder
      config = {config}
      shouldShow = {this.props.shouldShow}
      close = {this.props.close}
      fields = {[{type:"textarea", dbcol:"name", placeholder:"Naam", maxLength:"256"},
        {type:"labels", dbcol:"labels"},
        {type:"metadata", dbcol:"metadata"},
        {type:"hidden", dbcol:"id"}]}
      required_fields = {[{dbcol:"name", name:"Naam"}]}
      validate_fields = {[{dbcol:"name", name:"Naam"}]}
      label_list = {this.props.label_list}
      update_data = {this.props.update_data}
      api_method = "PATCH"
      api_endpoint = "/contact-update"
      api_block = "contact_update"
      api_block_clear = "contact_list"
      api_endpoint_delete = "/contact-delete"
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/ModalUpdateContact.js